/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum Xl8ServiceProvider {
    XL8_FILE_TRANSLATION = 'Xl8-FileTranslation',
    XL8_SYNC = 'Xl8-Sync',
    XL8_DUBBING = 'Xl8-Dubbing',
    XL8_SUB_BURNING = 'Xl8-SubBurning',
}
